import { axios } from "@/utils/request";

// 查询学习记录
export function queryBrowsingRecords(data) {
  return axios({
    url: "/browserHistory/queryBrowsingRecords",
    method: "POST",
    data
  });
}

// 查询最近的一条浏览二级记录
export function queryBrowsingRecordsLast(data) {
  return axios({
    url: "/browserHistory/queryBrowsingRecords/last",
    method: "PUT",
    data
  });
}

// /browserHistory/delete/records/{userId}
// 删除全部学习记录
export function deleteBrowserHistory(userId) {
  return axios({
    url: `/browserHistory/delete/records/${userId}`,
    method: "GET"
  });
}

// 删除某一条学习记录
export function deleteOneBrowserHistory(recordId) {
  return axios({
    url: `/browserHistory/delete/records/one/${recordId}`,
    method: "GET"
  });
}

// 收藏课程
export function collectCourse(courseId) {
  return axios({
    url: `/mark/star/${courseId}`,
    method: "GET"
  });
}

// 取消收藏课程
export function deleteCollectCourse(id) {
  return axios({
    url: `/mark/delete/${id}`,
    method: "GET"
  });
}

// 查询学段
export function getSectionList() {
  return axios({
    url: `/utils/query/semester`,
    method: "GET"
  });
}
